export default __webpack_public_path__ + "static/media/spinner.206d6921.svg";